import { render, staticRenderFns } from "./SwitchTypeModal.vue?vue&type=template&id=055be4ec"
import script from "./SwitchTypeModal.vue?vue&type=script&lang=js"
export * from "./SwitchTypeModal.vue?vue&type=script&lang=js"
import style0 from "./SwitchTypeModal.vue?vue&type=style&index=0&id=055be4ec&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.servis.leaseplan.cz/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055be4ec')) {
      api.createRecord('055be4ec', component.options)
    } else {
      api.reload('055be4ec', component.options)
    }
    module.hot.accept("./SwitchTypeModal.vue?vue&type=template&id=055be4ec", function () {
      api.rerender('055be4ec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/global/SwitchTypeModal.vue"
export default component.exports